/**
 * Provides a conditional logging utility that suppresses output in production.
 *
 * @module utils/debug
 * @author Snowfly
 * @version 1.0.0
 */

/**
 * A utility logging function that processes a message and logs it to the console,
 * provided the application is not in the production environment. The function
 * replaces all `%o` placeholders in the message with `%O` for compatibility
 * with Node.js logging conventions.
 *
 * @function
 * @param {string} message - The message to be logged, supporting placeholders.
 * @param {...any} args - Additional arguments to replace placeholders in the message.
 * @description This function checks the application's environment stage using the
 *              `REACT_APP_STAGE` environment variable. If the stage is not `prod`,
 *              the message along with its arguments is logged to the console.
 */
export const debug = function() {
    let message = arguments[0],
        args = Array.prototype.slice.call(arguments, 1);
    if ('string' === typeof message) {
        message = message.replaceAll(/%o/ig, '%O');
    }
    if (process.env.REACT_APP_STAGE !== 'prod') {
        console.log(message, ...args);
    }
};

export default debug;
